import { axiosApi } from './axios.api';
import { StoreModel } from '@app/interfaces/store';

const url = `/api/stores`;

export const getStoreApi = async (): Promise<StoreModel[] | undefined> => {
  try {
    const response = await axiosApi.get<StoreModel[]>(url);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};